import _ from 'lodash';
import type { FlowTask } from '@Types/FlowTask.interface';
import { useRequestFlowStore } from '@Stores/requestFlow.store';
import { useRequestSessionStore } from '@Stores/requestSession.store';
import {
    WHATS_NEXT_FLOW_TILES,
    WHATS_NEXT_PREPEND_TILES,
} from '@Constants/whatsnext.constants';


export const useWhatsNext = () => {
    const requestFlowStore = useRequestFlowStore();
    const requestSessionStore = useRequestSessionStore();

    /**
     * Tiles for the WhatsNext page.
     * Walks requiredFlows (backend order) and looks up each in WHATS_NEXT_FLOW_TILES.
     * Prepends any frontend-only tile from WHATS_NEXT_PREPEND_TILES for the current request type.
     * Deduplicates by displayName.
     */
    const getWhatsNextTasks = (): Partial<FlowTask>[] => {
        const requestType = requestSessionStore.requestSummary?.requestType;

        const prependTiles = _.compact(
            _.castArray(requestType ? WHATS_NEXT_PREPEND_TILES[requestType] ?? [] : [])
                .filter(tile => !!tile?.displayName)
        );

        const includedDisplayNames = new Set(
            prependTiles.map(t => t.displayName!),
        );

        const flowTiles = _.compact(
            _.map(requestFlowStore.requiredFlows, (flow) => {
                const tile = WHATS_NEXT_FLOW_TILES[flow];
                if (!tile?.displayName) return null;
                if (includedDisplayNames.has(tile.displayName)) return null;
                includedDisplayNames.add(tile.displayName);
                return tile;
            })
        );

        return [...prependTiles, ...flowTiles];
    };

    return { getWhatsNextTasks };
};

export default useWhatsNext;
